import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const CompanyAdminCourseAddLoader = async (args: LoaderFunctionArgs) => {

    const getEducationsResponse = await networkCall('/educations');

    return { getEducationsResponse, userId: args.params.id };

};